import styled, { keyframes, css } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

/**
 * Индикатор загрузки.
 *
 * Раньше вращение собиралось из четырёх отдельных SVG-файлов
 * (spinner_frame_0..3), которые переключались таймером — покадровая
 * анимация вместо плавной, четыре сетевых запроса вместо нуля.
 *
 * Цвет берётся из currentColor, поэтому спиннер вписывается в любой
 * контекст: на кнопке он белый, в таблице — цвета текста.
 */
export const Spinner = styled.span<{ $size?: string }>`
  display: inline-block;
  flex: 0 0 auto;
  border-radius: 50%;
  border: 0.2rem solid currentColor;
  border-right-color: transparent;
  animation: ${spin} 0.75s linear infinite;

  ${({ $size = "2rem" }) => css`
    width: ${$size};
    height: ${$size};
  `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`;

export default Spinner;
